

<!-- <div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">                             
                  <a routerLink="/project/activity-log"><button class="btn btn-primary me-2 " ><i class="fa  fa-arrow-left blink" aria-hidden="true"></i> Back</button></a>
                </div>
                <div class="card-body custom-datatable noscroll">
                    <div class="custom-datatable">
                            <table class="table">                            
                                    <tbody *ngIf="viewInsiderActivityList?.data[0]">
                                        <tr>
                                            <td scope="row">Action Flag</td>
                                            <td scope="row">{{viewInsiderActivityList?.data[0].action_flag}}</td>                                         
                                         </tr> 
                                         <tr>
                                            <td scope="row">Created By</td>
                                            <td scope="row">{{viewInsiderActivityList?.data[0].created_by}}</td>                                         
                                         </tr> 
                                         <tr>
                                            <td scope="row">Created On</td>
                                            <td scope="row">{{viewInsiderActivityList?.data[0].created_on}}</td>                                         
                                         </tr> 
                                         <tr>
                                            <td scope="row">Name</td>
                                            <td scope="row">{{viewInsiderActivityList?.data[0].name}}</td>                                         
                                         </tr> 
                                         
                                </tbody>
                            </table>
                    
                </div>
            </div>
        </div>
    </div>
 </div> -->

 <div class="modal-header">
    <h5 class="modal-title">View Insider Change log</h5>
    <button type="button" class="close" data-dismiss="modal" (click)="closeModal('dismiss')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                   
                    <div class="card-body custom-datatable noscroll">
                        <div class="custom-datatable">
                                <table class="table">                            
                                        <tbody *ngIf="viewInsiderActivityList">
                                     
                                            <tr>
                                                <td scope="row">Record</td>
                                                <td scope="row">{{viewInsiderActivityList.Record}}</td>                                         
                                             </tr> 
                                            <tr>
                                                <td scope="row">Activity</td>
                                                <td scope="row">{{viewInsiderActivityList.Activity}}</td>                                         
                                             </tr> 
                                             <tr>
                                                <td scope="row">Insider Name</td>
                                                <td scope="row">{{viewInsiderActivityList.name}}</td>                                         
                                             </tr> 
                                             <tr>
                                                <td scope="row">Action By (Username)</td>
                                                <td scope="row">{{viewInsiderActivityList.ActionBy}}</td>                                         
                                             </tr>                                            
                                             <tr>
                                                <td scope="row">Action Date</td>
                                                <td scope="row">{{viewInsiderActivityList.ActionOn | date:'dd-MM-yyyy HH:mm:ss'}}</td>                                         
                                             </tr> 
                                             <tr>
                                                <td scope="row">Reason for Change</td>
                                                <td scope="row">{{viewInsiderActivityList.reason}}</td>                                         
                                             </tr> 
                                             <tr>
                                                <td scope="row">Change Details</td>
                                                <td scope="row">{{viewInsiderActivityList.changedetails}}</td>                                         
                                             </tr> 
                                            
                                             
                                    </tbody>
                                </table>
                        
                    </div>
                </div>
            </div>
        </div>
     </div>
</div>
<div class="modal-footer">
    <!-- <div class="text-muted">
        <b>Note:</b> This section only respresent audit trail information.<br><br>
        <b>For Complete Details of the entry</b><br> please navigate to respective section in the software and view the full details (<i class="fa fa-eye" ></i>).
    </div> -->
    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeModal('close')">Close</button>
</div>